"use strict";

module.exports = {
  template: '<span ng-class="{\'text-danger\': $ctrl.countDown < 300}"' +
            '      title="Sie werden in {{ $ctrl.countDown/60 | number:0 }} Minuten automatisch vom System abgemeldet.">' +
            '  ({{ $ctrl.countDown/60 | number:0 }} min)' +
            '</span>',
  controller: ['$timeout', '$rootScope', function($timeout, $rootScope){
    var ctrl = this;

    // TODO get session timeout value from server
    var defaultTimeout = 3600;

    var interval, timeoutFn;

    this.countDown = defaultTimeout;

    this.$onInit = function(){
      timeoutFn = $timeout(ctrl.onTimeout, 1000);
    }

    this.$onDestroy = function(){
      $timeout.cancel(interval);
    }

    this.onTimeout = function(){
      if (ctrl.countDown >= 0){
        ctrl.countDown--;
        timeoutFn = $timeout(ctrl.onTimeout, 1000);
      }
    }

    $rootScope.$on('http:request', function(){
      ctrl.countDown = defaultTimeout;
    })
  }]
}



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/components/session-timeout.component.js